import React, { Component } from "react";
import { Link } from "react-router-dom";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import Constant from "../../Constant";

export default class UpdateCourse extends Component {
  state = {
    name: "",
    description: "",
    categoryId: "",
    image: "",
    content: null,
    categories: [],
  };
  componentDidMount() {
    this.getCourse();
    this.getCategories();
  }
  randomString = (length, chars) => {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }
  getCategories = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow"
    };

    fetch(Constant.getAPI() + "/category/getAll", requestOptions)
      .then(response => response.json())
      .then(result => {
        this.setState({ categories: result.data });
      })
      .catch(error => console.log("error", error));
  };
  handleDay = (date) => {
    this.setState({
      startDate: date,
    });
  };
  getCourse() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        var content = JSON.parse(data.content)
        this.setState({
          name: data.name,
          description: data.description,
          image: data.image,
          category_id: data.category_id,
          uniqueCourseID: data.uniqueCourseID,
          old_uniqueCourseID: data.uniqueCourseID,
          content: content,
          selfEnroll: content.selfEnroll,
          startDate: new Date(content.startDate),
          certification: content.certification,
          isPublic: content.isPublic,
          cost: content.cost,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  }

  updateCourse = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var content = {
      cost: this.state.cost,
      startDate: this.state.startDate.toISOString(),
      selfEnroll: this.state.selfEnroll,
      certification: this.state.certification,
      isPublic: this.state.isPublic
    }
    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);
    urlencoded.append("name", this.state.name);
    urlencoded.append("description", this.state.description);
    urlencoded.append("image", this.state.image);
    urlencoded.append("content", JSON.stringify(content));
    urlencoded.append("category_id", this.state.category_id);
    urlencoded.append("amount", content.cost);
    if(parseInt(content.cost) > 0 ){
      urlencoded.append("isPaid", true);
    }else{
      urlencoded.append("isPaid", false);
    }
    if (this.state.uniqueCourseID === undefined || this.state.uniqueCourseID === null || this.state.uniqueCourseID === "null" || this.state.uniqueCourseID === "") {
      var uniqueCourseID = this.randomString(6, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
      // this.setState({ uniqueCourseID: uniqueCourseID });
      urlencoded.append("uniqueCourseID", uniqueCourseID);
    } else if (this.state.old_uniqueCourseID !== this.state.uniqueCourseID) {
      urlencoded.append("uniqueCourseID", this.state.uniqueCourseID);
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.location.href = "#/admin/courses/";
      })
      .catch((error) => console.log("error", error));
  };
  uploadImg = (event) => {
    var that = this;
    var data = new FormData();
    data.append("siteId", localStorage.getItem("lms_site_id"));
    data.append("media", event.target.files[0]);
    fetch(Constant.getAPI() + "/media/add", {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("livelms_auth"),
      },
      body: data,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        if (json.status === true) {
          that.setState({ image: json.data[0].url });
          // window.location.reload();
          // alert("image uploaded");
        } else {
          console.log(json.error);
        }
      });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  onCategoryChange = (e) => {
    this.setState({ categoryId: e.target.value });
  };

  toggleSelfEnroll = (checked) => {
    this.setState({
      selfEnroll: checked,
    });
  };
  toggleIsPublic = (checked) => {
    this.setState({
      isPublic: checked,
    });
  };
  toggleCertification = (checked) => {
    this.setState({
      certification: checked,
    });
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/courses">Courses</Link> / <b> Add Course</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Course Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Course Name"
                  id="inputDefault"
                  name="name"
                  defaultValue={this.state.name}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Course Unique Code
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Course Unique Code"
                  id="inputDefault"
                  name="uniqueCourseID"
                  defaultValue={this.state.uniqueCourseID}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                  name="categoryId"
                >
                  Category
                </label>
                <select
                  class="custom-select col-8"
                  onChange={this.onCategoryChange}
                >
                  {this.state.categories.map((category) => (
                    <option defaultValue={category.id}>{category.name}</option>
                  ))}
                </select>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Cost
                </label>
                <input
                  type="number"
                  min={0}
                  class="form-control col-8"
                  placeholder="Cost for Course"
                  id="inputDefault"
                  name="cost"
                  defaultValue={this.state.cost}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Discription
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Add Course Discription"
                  id="inputDefault"
                  name="description"
                  defaultValue={this.state.description}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Self Enroll
                </label>
                <div>
                  <Switch
                    onChange={this.toggleSelfEnroll}
                    checked={this.state.selfEnroll}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Certification
                </label>
                <div>
                  <Switch
                    onChange={this.toggleCertification}
                    checked={this.state.certification}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Public Course
                </label>
                <div>
                  <Switch
                    onChange={this.toggleIsPublic}
                    checked={this.state.isPublic}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select Day
                </label>
                <div className="card border card-selector col-md-8 mini  d-flex flex-row day-picker">
                  <i class="far fa-calendar-alt" />
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleDay}
                    dateFormat="MMMM d, yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center flex-column">
              <input
                type="file"
                name="selectedFile"
                onChange={this.uploadImg}
              />
              {
                this.state.image
                  ?
                  this.state.image !== null || this.state.image !== undefined || this.state.image !== {}
                    ?
                    <img src={this.state.image} alt=""
                      className="image_square" onError={e => {
                        e.target.src = ""
                      }} />
                    :
                    ''
                  :
                  ''
              }
            </div>
          </div>

          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.updateCourse}>
              Save
            </div>{" "}
            or  <Link to="/admin/courses" className="btn-link">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}
